import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import { ResGetCountries } from './types'

export const getCountriesQuery = queryOptions({
  queryKey: [API_ENDPOINTS.business.country.index],
  queryFn: (): Promise<ResGetCountries> => w.get(API_ENDPOINTS.business.country.index).json(),
})
